
export type UserRole = 'regular' | 'broker' | 'peo' | 'super_admin';

export interface UserRoleOption {
  value: UserRole;
  label: string;
  description: string;
}

export const USER_ROLES: UserRoleOption[] = [
  {
    value: 'regular',
    label: 'Regular User',
    description: 'Access to find and request PEO services'
  },
  {
    value: 'broker',
    label: 'Broker',
    description: 'Submit applications on behalf of clients'
  },
  {
    value: 'peo',
    label: 'PEO Provider',
    description: 'Manage PEO services and respond to quotes'
  }
];

// Not exposed in the signup form, set programmatically
export const ADMIN_ROLES: UserRoleOption[] = [
  {
    value: 'super_admin',
    label: 'Super Admin',
    description: 'Full system access and configuration'
  }
];
